import React from 'react';
import { Table, Progress } from 'reactstrap';

import { PageSection } from './PageSection';

const VoteSummary = ({ activities = [] }) => {
    const voteCount = activities?.reduce((previousValue, currentValue) => previousValue + currentValue?.votes, 0);
    const sortedActivities = [...(activities || [])]?.sort((a,b) => b?.votes - a?.votes);

    return (
        <PageSection title="Activity Votes">
            <Table style={{ whiteSpace:'nowrap' }}>
                <tbody>
                    {sortedActivities?.map(({ name, preferredActivityId, votes }) =>
                        <tr key={preferredActivityId}>
                            <td width="auto">{name}</td>
                            <td width="100%">
                                <Progress value={votes} max={voteCount}>
                                    {votes}
                                </Progress>
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </PageSection>
    );
}

export default VoteSummary;